import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { getAllNannyPayments } from '../../store/apiSlice/nannyPaymentSlice';
import { format } from 'date-fns';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Typography
} from '@mui/material';
import { Link } from 'react-router-dom';

const NannyPayments = () => {
    const dispatch = useDispatch();
    const paymentData = useSelector((state) => state.rootReducer.paymentsReducer.data);
    const [payments, setPayments] = useState(null)

    useEffect(() => {
        dispatch(getAllNannyPayments())
    }, [])

    useEffect(() => {
        if (paymentData && paymentData.status === 1) {
            setPayments(paymentData.data)
        }
    }, [paymentData])

    return (
        <div className="row" >
            <div style={{ padding: '2rem', paddingTop: '0.5rem' }}>
                <Typography variant="h5" gutterBottom style={{ paddingBottom: '1rem' }}>
                    Payment History
                </Typography>

                {payments && <TableContainer component={Paper}>
                    <Table aria-label="payment table">
                        <TableHead>
                            <TableRow >
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Order ID</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Amount</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Currancy</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Gateway</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Date</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Invoice</TableCell>
                                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments?.length > 0 ? (
                                payments.map((payment, index) => (
                                    <TableRow key={payment._id}>
                                        <TableCell>{payment?.orderId}</TableCell>
                                        <TableCell>€{(payment?.finalPrice).toFixed(2)}</TableCell>
                                        <TableCell>{payment?.paymentId ? payment.paymentId.currency : 'EUR'}</TableCell>
                                        <TableCell>{payment?.paymentId ? payment.paymentId.paymentGateway : 'stripe'}</TableCell>
                                        <TableCell>{format(new Date(payment.createdAt), 'MMMM d, yyyy') || 'NA'}</TableCell>
                                        <TableCell>
                                            <Link to={payment?.paymentId ? payment?.paymentId?.receiptUrl : null} target="_blank" rel="noopener noreferrer">
                                                View
                                            </Link>
                                        </TableCell>
                                        <TableCell>{ payment?.paymentId?.stripePaymentStatus ? payment?.paymentId?.stripePaymentStatus : payment?.paymentId?.paymentStatus}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No payments found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>}
            </div>
        </div>
    )
}

export default NannyPayments
